var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["badge-activity-status", "is-" + _vm.tag.type] },
    [
      _vm.tag.icon
        ? _c("CompassIcon", {
            attrs: { size: "extra-small", icon: _vm.tag.icon }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "typographies-paragraph-small-regular" }, [
        _vm._v(_vm._s(_vm.tag.label))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }